import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import Modal from '../Modal/Modal';
import Icons from '../Icons/Icons';

import css from './IOSInstallInstructions.module.css';

const IOSInstallInstructions = ({ isVisible, onClose }) => {
  if (!isVisible) return null;

  return (
    <div className={css.overlay} onClick={onClose}>
      <div className={css.modal} onClick={e => e.stopPropagation()}>
        <div className={css.header}>
          <h3 className={css.title}>
            <FormattedMessage id="IOSInstallInstruction.title" />
          </h3>
          <button className={css.closeButton} onClick={onClose}>
            <Icons name="close" />
          </button>
        </div>

        <div className={css.content}>
          <div className={css.appInfo}>
            <div className={css.appIcon}>
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="40" height="40" rx="8" fill="#007AFF" />
                <circle cx="20" cy="20" r="12" fill="white" />
                <text
                  x="20"
                  y="25"
                  textAnchor="middle"
                  fill="#007AFF"
                  fontSize="12"
                  fontWeight="bold"
                >
                  OB
                </text>
              </svg>
            </div>
            <div className={css.appDetails}>
              <div className={css.appName}>
                <FormattedMessage id="IOSInstallInstructions.appName" />
              </div>
              <div className={css.appUrl}>
                <FormattedMessage id="IOSInstallInstructions.appUrl" />
              </div>
            </div>
          </div>

          <div className={css.steps}>
            <div className={css.step}>
              <div className={css.stepNumber}>1</div>
              <div className={css.stepContent}>
                <p className={css.stepText}>
                  <FormattedMessage
                    id="IOSInstallInstruction.step1"
                    values={{
                      shareIcon: (
                        <span className={css.shareIcon}>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="13px"
                            viewBox="0 -960 960 960"
                            width="15px"
                            fill="#000000"
                          >
                            <path d="M444-336v-342L339-573l-51-51 192-192 192 192-51 51-105-105v342h-72ZM263.72-192Q234-192 213-213.15T192-264v-72h72v72h432v-72h72v72q0 29.7-21.16 50.85Q725.68-192 695.96-192H263.72Z" />
                          </svg>
                        </span>
                      ),
                    }}
                  />
                </p>
              </div>
            </div>

            <div className={css.step}>
              <div className={css.stepNumber}>2</div>
              <div className={css.stepContent}>
                <p className={css.stepText}>
                  <FormattedMessage id="IOSInstallInstruction.step2" />
                </p>
              </div>
            </div>

            <div className={css.step}>
              <div className={css.stepNumber}>3</div>
              <div className={css.stepContent}>
                <p className={css.stepText}>
                  <FormattedMessage
                    id="IOSInstallInstructions.step3"
                    values={{
                      appIconSmall: (
                        <span className={css.appIconSmall}>
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect width="16" height="16" rx="3" fill="#007AFF" />
                            <circle cx="8" cy="8" r="5" fill="white" />
                          </svg>
                        </span>
                      ),
                    }}
                  />
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

IOSInstallInstructions.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default IOSInstallInstructions;
